import { Button, Modal } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NewClientForm } from "../NewClientForm";

export interface QuickClientProps {}

export const QuickClient = () => {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Modal
        size="lg"
        opened={opened}
        onClose={() => setOpened(false)}
        closeOnClickOutside={false}
        overlayProps={{
          color: "white",
          opacity: 0.55,
          blur: 3,
        }}
      >
        <NewClientForm quick />
      </Modal>
      <Button compact onClick={() => setOpened(true)}>
        {t("NEW_CLIENT")}
      </Button>
    </>
  );
};
